var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAssistantPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ai-assistant-play-circle_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.5 21.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ai-assistant-play-circle_svg__st0{fill:#6ad09d}.ai-assistant-play-circle_svg__st1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ai-assistant-play-circle_svg__st0",
    d: "M10.8 20.8c5.5 0 10-4.5 10-10s-4.5-10-10-10-10 4.4-10 10 4.5 10 10 10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ai-assistant-play-circle_svg__st0",
    d: "M8.2 7.7v-.8c0-.1.2-.2.4-.2s.4.1.8.4l4.7 3c.3.2.5.3.6.5v.4c0 .1-.2.3-.6.5l-4.7 3c-.4.3-.6.4-.8.4-.1 0-.3 0-.4-.2V7.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "ai-assistant-play-circle_svg__st1",
    d: "M10.8 20.8c5.5 0 10-4.5 10-10s-4.5-10-10-10-10 4.4-10 10 4.5 10 10 10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ai-assistant-play-circle_svg__st1",
    d: "M8.2 7.7v-.8c0-.1.2-.2.4-.2s.4.1.8.4l4.7 3c.3.2.5.3.6.5v.4c0 .1-.2.3-.6.5l-4.7 3c-.4.3-.6.4-.8.4-.1 0-.3 0-.4-.2V7.8z"
  })));
}
export default SvgAiAssistantPlayCircle;